import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavbarPocessoService {

  notificador: EventEmitter<number> = new EventEmitter();
  constructor() { }


  adicionar(id: number) {
    this.notificador.emit(id);
  }
}
